import {InputBase, styled, TextareaAutosize} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Select from "@mui/material/Select";

interface inputInterface {
    fullHeight?: any;
}

export const StyledSelect = styled(Select)(({theme}) => ({
    flexDirection: "row",
    fontSize: "14px",

    "&.MuiOutlinedInput-root": {
        border: `solid 2px #e6e6e6`,
        borderRadius: "4px",
        height: "40px",
        "& fieldset": {
            border: "none",
        },
        ".css-1d9mq0f-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-1d9mq0f-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-1d9mq0f-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
            {
                paddingLeft: "22px",
                paddingRight: "10px",
            },
        "& svg": {
            position: "absolute",
            right: "unset",
            left: "7px",
        },
    },
    "&.MuiInputBase-input": {
        backgroundColor: "blue",
    },
}));

export const StyledInputBase = styled(InputBase)(({theme}) => ({
    borderColor: "#e6e6e6",
    borderRadius: "4px",
    borderWidth: "2px",
    borderStyle: "solid",
    fontSize: "14px",
    paddingRight: "10px",
    width: "170px",
    height: "30px",
    "&:focus-within": {
        borderColor: `${theme.palette.primary.main} !important`,
    },
    "&:disabled": {
        borderColor: `red !important`,
    },
}));
export const StyledTextareaAutosize = styled(TextareaAutosize)(({theme}) => ({
    width: "100%",
    borderColor: theme.palette.disabled.contrastText,
    padding: "10px",
    borderRadius: "4px",
    fontSize: "14px",
    "&:focus-within": {
        borderColor: `${theme.palette.primary.main} !important`,
    },
    "&:focus": {
        borderColor: `${theme.palette.primary.main} !important`,
    },
}));

export const StyledAutocomplete = styled(Autocomplete)<inputInterface>(({theme, fullHeight}) => ({
    flexDirection: "row",
    fontSize: "14px",

    "&.MuiAutocomplete-root": {
        border: fullHeight ? "" : `solid 2px #e6e6e6`,
        borderRadius: "4px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        height: fullHeight ? "100%" : "40px",
        "& fieldset": {
            border: "none",
            padding: 0,
        },
        ".css-wb57ya-MuiFormControl-root-MuiTextField-root": {
            padding: "0",
            height: "40px",
            "& div": {
                padding: "0 10px 0 0 !important",
                "& div": {
                    left: 9,
                    right: "unset",
                },
                "& input": {
                    right: 0,
                },
            },
        },
    },
}));
